var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlow2 = function SvgFlow2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#494743",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M1 12.243h4.19m17.81 0-2.619-2.054M23 12.243l-2.619 2.568M23 12.243H5.19m0 0 .037-.357a7.603 7.603 0 0 1 7.564-6.832H23m-17.81 7.19.056.545a7.965 7.965 0 0 0 7.925 7.157H23m0-14.892L20.381 3M23 5.054l-2.619 2.568M23 19.946l-2.619-2.054M23 19.946 20.381 22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .143h24v24H0z"
  })))));
};
export default SvgFlow2;